var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page-shell-wrapper"},[_c('HeadNav',{attrs:{"locale":_vm.locale}}),_c('main',{staticClass:"page-shell"},[(_vm.pageTitle && !_vm.hideTitle)?_c('h1',{staticClass:"page-shell__title"},[_vm._v(_vm._s(_vm.pageTitle))]):_vm._e(),_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }